export default __webpack_public_path__ + "static/media/bttn-appstore.67c22c7e.svg";